import { render, staticRenderFns } from "./PaymentTypeDetails.vue?vue&type=template&id=24956e61&"
import script from "./PaymentTypeDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports